function formatTimeDelta(seconds) {
  var days = Math.floor(seconds / (3600 * 24));
  var hours = Math.floor(seconds / 3600) - days * 24;
  var minutes = "0" + Math.floor(seconds / 60 - hours * 60);
  var seconds = "0" + Math.floor(seconds - hours * 3600 - minutes * 60);

  days = days.toString();
  hours = hours.toString();
  minutes = minutes.toString();
  seconds = seconds.toString();

  var time = "";
  if (days > 0) time += days + "d " + hours.substring(hours.length - 2) + "h ";
  else if (hours > 0)
    time = hours + "h " + minutes.substring(minutes.length - 2) + "min";
  else
    time =
      minutes.substring(minutes.length - 2) +
      "min " +
      seconds.substring(seconds.length - 2) +
      "s";
  return time;
}

function formatMinSec(seconds) {
  if (!seconds) return "00:00 min";
  const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
  const secs = String(Math.floor(seconds % 60)).padStart(2, "0");
  return `${mins}:${secs} min`;
}

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}:${month}:${year}`;
};

function formatDateDDMMYYYY(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function formatISOTimestamp(timeString) {
  if (!timeString.endsWith("Z")) {
    timeString += "Z";
  }
  const date = new Date(timeString);
  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Berlin",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  try {
    const parts = formatter.formatToParts(date);
    const get = (type) => parts.find((p) => p.type === type)?.value;

    return `${get("year")}-${get("month")}-${get("day")} ${get("hour")}:${get(
      "minute"
    )}:${get("second")}`;
  }
  catch (error) {
    console.error("Error formatting date:", error);
    return timeString;
  }
}

function formatPercentage(number) {
  return Math.round(number * 100) + "%";
}

function sort_object(obj) {
  let items = Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
  items.sort(function (first, second) {
    return second[1] - first[1];
  });
  let use_key;
  let use_value;
  let sorted_obj = {};
  items.forEach(function (v) {
    use_key = v[0];
    use_value = v[1];
    sorted_obj[use_key] = use_value;
  });
  return sorted_obj;
}

function extractErrors(err) {
  return err.inner.reduce((acc, err) => {
    return { ...acc, [err.path]: err.message };
  }, {});
}

function hslToHex(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, "0"); // convert to Hex and prefix "0" if needed
  };
  return `#${f(0)}${f(8)}${f(4)}`;
}

export {
  extractErrors,
  formatDate,
  formatDateDDMMYYYY,
  formatISOTimestamp, formatMinSec, formatPercentage,
  formatTimeDelta,
  hslToHex,
  sort_object
};

